module.exports = __webpack_public_path__ + "img/usa.d929cd01.svg";